import { render } from "./author-identity.vue?vue&type=template&id=1e11c246&scoped=true"
import script from "./author-identity.vue?vue&type=script&lang=js"
export * from "./author-identity.vue?vue&type=script&lang=js"

import "./author-identity.vue?vue&type=style&index=0&id=1e11c246&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/thinkcloud/thinkcloud-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e11c246"]])

export default __exports__